import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-recommend-form__field" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "住所"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "履")
], -1)
const _hoisted_3 = { class: "p-recommend-form__group-1 --type-2 js-kana-wrap" }
const _hoisted_4 = { class: "p-recommend-form__error-wrap" }
const _hoisted_5 = { class: "p-recommend-form__group-1-field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode("郵便番号"),
  /*#__PURE__*/_createElementVNode("span", { class: "-is-required" }, "必須")
], -1)
const _hoisted_7 = { class: "p-recommend-form__group-1-zip" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "住所を自動入力", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "p-recommend-form__group-1-field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode("都道府県"),
  /*#__PURE__*/_createElementVNode("span", { class: "-is-required" }, "必須")
], -1)
const _hoisted_14 = { class: "p-recommend-form__group-1-field" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode("市区町村"),
  /*#__PURE__*/_createElementVNode("span", { class: "-is-required" }, "必須")
], -1)
const _hoisted_16 = { class: "p-recommend-form__group-1-field" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode("町名番地"),
  /*#__PURE__*/_createElementVNode("span", { class: "-is-required" }, "必須")
], -1)
const _hoisted_18 = { class: "p-recommend-form__group-1-field" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "建物名・部屋番号", -1)
const _hoisted_20 = { class: "p-recommend-form__group-1-field" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "都道府県カナ", -1)
const _hoisted_22 = { class: "p-recommend-form__group-1-field" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "市区町村カナ", -1)
const _hoisted_24 = { class: "p-recommend-form__group-1-field" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "町名・建物名カナ", -1)

import InvalidMessage from '@/components/InvalidMessage.vue';
import ValidatableField from '@/components/ValidatableField.vue';
import ResumeSelect from '../components/ResumeSelect.vue';
import { ref, watch } from 'vue';
import { getZipCodeService } from '@/api/services/trnCareerService';
import { useFieldValue, ValidationResult } from 'vee-validate';

type Props = {
    setFieldValue: <T extends string>(field: T, value: any, opts?: any) => void;
    validateField: (field: string) => Promise<ValidationResult>;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'AddressInfoForm',
  props: {
    setFieldValue: null,
    validateField: null
  },
  setup(__props: any) {

const props = __props as {
    setFieldValue: <T extends string>(field: T, value: any, opts?: any) => void;
    validateField: (field: string) => Promise<ValidationResult>;
}



const loadZipCodeData = async (zipCode: string) => {
  const zipCodeResp = await getZipCodeService(zipCode);
  if (zipCodeResp && zipCodeResp.length > 0) {
    return zipCodeResp[0];
  }
};

const zipId1Field = useFieldValue('zipId1');
const zipId2Field = useFieldValue('zipId2');
const zipId1 = ref('');
const zipId2 = ref('');

watch(zipId1Field, (newVal) => {
  zipId1.value = newVal as string;
}, { immediate: true });
watch(zipId2Field, (newVal) => {
  zipId2.value = newVal as string;
},{ immediate: true });

const fillValueFromZipcode = async () =>
{
    let isNotExist = true;
    const zipCode1 = zipId1.value;
    const zipCode2 = zipId2.value;
    if(zipCode1 && zipCode2 && zipCode1.length == 3 && zipCode2.length == 4 )
    {
        const zipCode = zipCode1 + zipCode2;
        const zipCodeInfo = await loadZipCodeData(zipCode);
        if(zipCodeInfo)
        {
            isNotExist = false;
            props.setFieldValue('prefId', zipCodeInfo.prefId);
            props.setFieldValue('prefKanaName', zipCodeInfo.prefKanaName);
            props.setFieldValue('addr1', zipCodeInfo.cityName);
            props.setFieldValue('addr1Kana', zipCodeInfo.cityKanaName);
            props.setFieldValue('addr2', zipCodeInfo.blockName);
            props.setFieldValue('addr2Kana', zipCodeInfo.blockKanaName);
        }
    }
    if(isNotExist)
    {
        props.setFieldValue('zipId1', '');
        props.setFieldValue('zipId2', '');
        props.setFieldValue('prefId', '');
        props.setFieldValue('prefKanaName', '');
        props.setFieldValue('addr1', '');
        props.setFieldValue('addr1Kana', '');
        props.setFieldValue('addr2', '');
        props.setFieldValue('addr2Kana', '');
    }
     await props.validateField('zipId1');
     await props.validateField('zipId2');
     await props.validateField('prefId');
     await props.validateField('addr1');
     await props.validateField('addr2');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(InvalidMessage, { name: "zipId1" }),
        _createVNode(InvalidMessage, { name: "zipId2" }),
        _createVNode(InvalidMessage, { name: "prefId" }),
        _createVNode(InvalidMessage, { name: "addr1" }),
        _createVNode(InvalidMessage, { name: "addr2" }),
        _createVNode(InvalidMessage, { name: "addr3" }),
        _createVNode(InvalidMessage, { name: "addr1Kana" }),
        _createVNode(InvalidMessage, { name: "addr2Kana" })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _createVNode(ValidatableField, {
              class: "p-recommend-form__input-1 --zip-1",
              id: "form-zip-1",
              type: "text",
              name: "zipId1",
              placeholder: "000",
              label: "郵便番号（前半）",
              rules: "required|numeric|nullableMin:3|max:3",
              maxlength: "3"
            }),
            _hoisted_8,
            _createVNode(ValidatableField, {
              class: "p-recommend-form__input-1 --zip-2",
              id: "form-zip-2",
              type: "text",
              name: "zipId2",
              placeholder: "0000",
              label: "郵便番号（後半）",
              rules: "required|numeric|nullableMin:4|max:4",
              maxlength: "4"
            })
          ]),
          _createElementVNode("button", {
            onClick: _withModifiers(fillValueFromZipcode, ["prevent"]),
            class: "p-recommend-form__zip-button",
            type: "button"
          }, _hoisted_11, 8, _hoisted_9)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(ResumeSelect, {
          name: `prefId`,
          label: "都道府県",
          id: "pref",
          rules: "required",
          className: "p-recommend-form__select",
          "empty-text": "都道府県を選択してください"
        })
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(ValidatableField, {
          class: "p-recommend-form__modal-input-2",
          id: "form-address-1",
          type: "text",
          rules: "required|max:100",
          maxlength: "100",
          name: "addr1",
          placeholder: "市区町村を入力してください",
          label: "市区町村"
        })
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode(ValidatableField, {
          class: "p-recommend-form__modal-input-2",
          id: "form-address-2",
          type: "text",
          rules: "required|max:200",
          maxlength: "200",
          name: "addr2",
          placeholder: "町名番地を入力してください",
          label: "町名番地"
        })
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createVNode(ValidatableField, {
          class: "p-recommend-form__modal-input-2",
          id: "form-address-3",
          type: "text",
          name: "addr3",
          placeholder: "建物名・部屋番号を入力してください",
          label: "建物名・部屋番号",
          rules: "max:70",
          maxlength: "70"
        })
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createVNode(ValidatableField, {
          class: "p-recommend-form__modal-input-2 js-ken-kana",
          id: "form-area-kana",
          type: "text",
          name: "prefKanaName",
          placeholder: "都道府県のカナを入力してください",
          label: "都道府県カナ",
          readonly: ""
        })
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createVNode(ValidatableField, {
          class: "p-recommend-form__modal-input-2",
          id: "form-address-1-kana",
          type: "text",
          name: "addr1Kana",
          placeholder: "市区町村のカナを入力してください",
          label: "市区町村カナ",
          rules: "zen_kana|max:70",
          maxlength: "70"
        })
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createVNode(ValidatableField, {
          class: "p-recommend-form__modal-input-2",
          id: "form-address-2-kana",
          type: "text",
          name: "addr2Kana",
          placeholder: "町名・建物名のカナを入力してください",
          label: "町名・建物名カナ",
          rules: "zen_kana|max:70",
          maxlength: "70"
        })
      ])
    ])
  ]))
}
}

})